exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-orders-supplier-list .span-margin-left{margin-left:20px}.purchase-orders-supplier-list .danger-status{color:#d9534f}.purchase-orders-supplier-list .filter-margin-top{margin-top:10px}.purchase-orders-supplier-list .create-purchase-order{margin-top:18px}", ""]);

// exports
